const localApi = "http://localhost:5050/api";
const productionApi = "https://api.mozogroup.in/api";
const browserHost = typeof window !== "undefined" ? window.location.hostname : "";

const API_BASE_URL = (
 process.env.REACT_APP_API_URL ||
 (browserHost === "localhost" || browserHost === "127.0.0.1" ? localApi : productionApi)
).replace(/\/$/, "");

export async function apiRequest(path, options = {}) {
 const response = await fetch(`${API_BASE_URL}${path}`, {
  headers: {
   "Content-Type": "application/json",
   ...(options.headers || {}),
  },
  ...options,
 });

 const data = await response.json().catch(() => ({}));

 if (!response.ok) {
  throw new Error(data.error || "API request failed");
 }

 return data;
}

export { API_BASE_URL };
